import { render, staticRenderFns } from "./CardBasic.vue?vue&type=template&id=185e38ce&scoped=true"
import script from "./CardBasic.vue?vue&type=script&lang=js"
export * from "./CardBasic.vue?vue&type=script&lang=js"
import style0 from "./CardBasic.vue?vue&type=style&index=0&id=185e38ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e38ce",
  null
  
)

export default component.exports